import {ISearchPage,ICmSearchPageFields} from "../../../types/FmsTypes";
export enum DetailType {
    "add" = "add",
    "edit" = "edit",
    "look" = "look"
}
//目录参数
export interface ICatalogParams {
    tableName?:string,
    code?:string,
    defaultBranchCode?:string,
}
export interface ICatalogDetail {
    "note"?: string,
    "code"?: string,
    "defaultBranchCode"?: string,
    "allowRemoteSelect"?: number|boolean|undefined|string,
    "allowRemoteUpdate"?: number|boolean|undefined|string,
    "allowRemoteInsert"?: number|boolean|undefined|string,
    "allowMultiBranch"?: number|boolean|undefined|string,
    "key"?: string,
    "tableName"?: string,
    "allowRemoteDelete"?: number|boolean|undefined|string,
    "status"?: number|boolean|undefined|string
}
//数据参数
export interface FieldParams {
    catalog?:string
}
export interface ICatalogSearch extends ICatalogParams,ICmSearchPageFields{

}

export interface FieldSearch extends FieldParams,ICmSearchPageFields{

}